import {NgModule} from '@angular/core';
import {MultilayerPlanComponent} from './multilayer-plan.component';
import {SharedModule} from '../../core/shared.module';
import {UIRouterModule} from '@uirouter/angular';
import {MULTILAYER_PLAN_STATES} from './multilayer-plan.states';

@NgModule({
  imports: [
    SharedModule,
    UIRouterModule.forChild({states: MULTILAYER_PLAN_STATES}),
    MultilayerPlanComponent,
  ]
})
export class MultilayerPlanModule {}
